import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { Field } from "react-final-form";
import { Checkbox } from "@ebsco-ui/ebsco-ui";

import "./checkbox-field.scss";

const CheckboxField = ({
  label,
  id,
  name,
  validationSchema,
  className,
  ...rest
}) => {
  const validateWithSchema = value => {
    if (validationSchema) {
      try {
        validationSchema.validateSync(value);
      } catch (error) {
        return error;
      }
    }
  };

  const getIsFieldInvalid = meta => {
    const hasError = meta.error && meta.submitFailed;
    const hasSubmitError = meta.submitError?.length > 0;
    return Boolean(hasError || (hasSubmitError && !meta.dirtySinceLastSubmit));
  };

  return (
    <Field id={id} name={name} type="checkbox" validate={validateWithSchema}>
      {({ input, meta }) => (
        <Checkbox
          id={id}
          checked={input.checked}
          className={cn(
            "checkbox-field",
            getIsFieldInvalid(meta) && "checkbox-field--invalid",
            className
          )}
          aria-invalid={getIsFieldInvalid(meta)}
          label={label}
          {...input}
          {...rest}
        />
      )}
    </Field>
  );
};

CheckboxField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  validationSchema: PropTypes.object,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export { CheckboxField };
export default CheckboxField;
